import { runtime, Runtime } from './envRuntime';

export enum AccountStatus {
  Exception = -1, // 异常
  Normal = 0, // 不管控
  WeakConstraint, // 弱管控
  Constraint, // 强管控
  Freeze, // 冻结
  BalanceFreeze, // 账户201余额被冻结，具体可参考 https://km.sankuai.com/collabpage/1736417962
  AccountConfirm, // 提醒用户更换实名等信息
  ProactiveFreeze, // 除5，6，7冻结原因的其他冻结情况，具体可参考 https://km.sankuai.com/collabpage/2616314001 冻结原因枚举
  Default, // 兜底弹窗
  CertificateWillExpire, // 证件临近过期
  CertificateExpired, // 证件已过期
  AccountFrozenGuideClosePayAccountWithdraw, // 余额冻结引导
  AccountFrozenGuideCanWithdraw, // 余额冻结引导,用户可使用提现
  PassportInternalAccountGuide, // 护照过期
  AccountFrozenGuideMarkClosePayAccount, // 余额冻结引导,用户可通过"假"关闭支付账户，使用提现
  ProactiveFrozenGuideMarkClosePayAccount = 14, // 证件过期冻结/解冻 引导，用户可通过"假"关闭支付账户，使用提现
}

export const APP_SAFARI_SCHEMA: any = {
  group: 'meituanpayment://cashier',
  waimai: 'meituanpayment://cashier',
  'dianping-nova': 'meituanpayment://cashier',
};

export const OPEN_APP_SCHEME: any = {
  group: 'imeituan://www.meituan.com',
  waimai: 'meituanwaimai://waimai.meituan.com',
  'dianping-nova': 'dianping://',
};

export const APP_ORDER_SCHEME: any = {
  group: 'imeituan://www.meituan.com/home',
  waimai: 'meituanwaimai://waimai.meituan.com/pois',
  'dianping-nova': 'dianping://home',
};

export const HARMONY_MT_MAIN_PAGE = 'imeituan://www.meituan.com/har/feature/homePage';

export const questionTitleAccess = '//p0.meituan.net/travelcube/b52036e7c87d40c367c7251288695016297.png';

export const questionSubTitleAccess = '//p0.meituan.net/travelcube/b52036e7c87d40c367c7251288695016297.png';

export const safetyIcon = '//s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/icon-safety.png';

export const indexFuncModal: Array<any> = [
  {
    iconClass: '',
    iconUrl: 'https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/icon-balance-new.png',
    text: '查询名下账号',
    item: 'check-account',
    id: 3,
  },
  {
    iconClass: '',
    iconUrl:
      'https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/satisfaction-feedback-new.png',
    text: '满意度反馈',
    item: 'satisfaction-feedback',
    id: 4,
  },
  {
    iconClass: '',
    iconUrl:
      'https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/icon-change-realname.png',
    text: '更换实名',
    item: 'change-realname',
    id: 5,
  },
];

export const billListFuncModal: Array<any> = [
  {
    iconClass: '',
    iconUrl: 'https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/icon-faq-new.png',
    text: '常见问题',
    item: 'questions',
    id: 1,
  },
  {
    iconClass: '',
    iconUrl: 'https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/icon-records-new.png',
    text: '历史余额明细',
    item: 'check-bill',
    id: 2,
  },
];

export const withdrawFuncModal: Array<any> = [
  {
    iconClass: '',
    iconUrl: 'https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/icon-records-new.png',
    text: '提现记录',
    item: 'check-bill',
    id: 1,
  },
  {
    iconClass: '',
    iconUrl: 'https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/icon-faq-new.png',
    text: '常见问题',
    item: 'questions',
    id: 2,
  },
  {
    iconClass: '',
    iconUrl:
      'https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/icon-change-realname.png',
    text: '更换实名',
    item: 'change-realname',
    id: 3,
  },
];

export const baLanceMoneySet = {
  open: 'https://p0.meituan.net/xyconsole/5526831a9361a75c8a9bc2b0b2e5e821536.png',
  close: 'https://p0.meituan.net/xyconsole/59eb0ab2b6d4c12080fd17af1e0dbe9b568.png',
};

export const navRightButton = 'https://p0.meituan.net/wxapp/fd68ff048524e9532d4bfc986c7dfec3506.png';

export const appNameId: any = {
  group: 0, // 美团
  waimai: 4, // 外卖
  'dianping-nova': 11, // 点评
  meituanyouxuan_app: 149, // 美团优选
  conch: 23, // 美团钱包app
  movie: 1, // 猫眼app
  daxiang: 28, // 大象
  moma: 98, // 盘古
  zhenguo: 30, // 榛果
  mtmaicai: 95, // 美团买菜
  groupTurbo: 113, // 美团极速版
};

export const CERTIFY_CHANNEL_URL = {
  [Runtime.Prod]: 'https://paymp.meituan.com/certify-center/certify-channel.html',
  [Runtime.Staging]: 'https://paymp.pay.st.sankuai.com/certify-center/certify-channel.html',
  [Runtime.Test]:
    window.location.origin.indexOf('-sl-') > 0
      ? `${window.location.origin.split('-sl-')[0]}-sl-paymp.pay.test.sankuai.com/certify-center/certify-channel.html`
      : 'https://paymp.pay.test.sankuai.com/certify-center/certify-channel.html',
  [Runtime.Dev]: 'https://paymp.pay.test.sankuai.com/certify-center/certify-channel.html',
  [Runtime.Local]: 'https://paymp.pay.test.sankuai.com/certify-center/certify-channel.html',
};
// DSP接口域名
export const MGM_HOST = {
  [Runtime.Prod]: 'https://mgm.meituan.com',
  [Runtime.Staging]: 'https://mgm.fin.st.meituan.com',
  [Runtime.Test]:
    window.location.origin.indexOf('-sl-') > 0
      ? `${window.location.origin.split('-sl-')[0]}-sl-mgm.fin.test.sankuai.com`
      : 'https://mgm.fin.test.sankuai.com',
  [Runtime.Dev]: `http://suxin12-umtcu-sl-mgm.fin.test.sankuai.com`,
  [Runtime.Local]: `http://suxin12-umtcu-sl-mgm.fin.test.sankuai.com`,
};
// 独立验证web版
export const PASS_VERIFY_WEB_URL = {
  [Runtime.Prod]: 'https://npay.meituan.com/resource/pass-verify/index.html',
  [Runtime.Staging]: 'https://stable.pay.st.sankuai.com/resource/pass-verify/index.html',
  [Runtime.Test]: 'http://stable.pay.test.sankuai.com/resource/pass-verify/index.html',
  [Runtime.Dev]: 'http://stable.pay.test.sankuai.com/resource/pass-verify/index.html',
  [Runtime.Local]: 'http://stable.pay.test.sankuai.com/resource/pass-verify/index.html',
};

export const RECORD_TABS = {
  balanceDetail: [
    {
      type: 0,
      name: '全部',
    },
    {
      type: 1,
      name: '收入',
    },
    {
      type: 2,
      name: '支出',
    },
  ],
  withdrawDetail: [
    {
      type: 0,
      name: '提现成功',
    },
    {
      type: 1,
      name: '提现失败',
    },
  ],
};

export enum OrderStatus {
  INIT = 0,
  PROCESSING = 1,
  SUCCESS = 2,
  FAIL = 3,
}

export const EMPTY_LIST_TIP = {
  balanceDetail: {
    title: '没有查询到相关信息',
    subTitle: '找找更早时间的吧',
    buttonName: '查询其它时间',
    showButton: true,
    bottomTip: '- 更早时间明细请通过筛选月份查看 -',
  },
  withdrawDetail: {
    title: '没有查询到相关信息',
    subTitle: '更多记录可到余额明细中查看',
    buttonName: '查看其他时间',
    showButton: false,
    bottomTip: '- 更多记录可到余额明细中查看 -',
  },
  refundDetail: {
    title: '暂无记录',
    subTitle: '当前仅支持查询2014年3月至2017年9月的记录',
    buttonName: '',
    showButton: false,
    bottomTip: '- 暂无更多记录 -',
  },
};

export const REAL_NAME_SEARCH_URL = {
  [Runtime.Prod]: 'https://awp.meituan.com/ffe/verified-sdk/real-name-search.html',
  [Runtime.Staging]: 'https://paymp.pay.st.sankuai.com/verified-sdk/real-name-search.html',
  [Runtime.Test]: 'https://paymp.pay.test.sankuai.com/verified-sdk/real-name-search.html',
  [Runtime.Dev]: 'https://paymp.pay.test.sankuai.com/verified-sdk/real-name-search.html',
  [Runtime.Local]: 'https://paymp.pay.test.sankuai.com/verified-sdk/real-name-search.html',
};

export const CHANGE_REAL_NAME_URL = {
  [Runtime.Prod]: 'https://paymp.meituan.com/certify-center/change-realname.html',
  [Runtime.Staging]: 'https://paymp.pay.st.sankuai.com/certify-center/change-realname.html',
  [Runtime.Test]: 'https://paymp.pay.test.sankuai.com/certify-center/change-realname.html',
  [Runtime.Dev]: 'https://paymp.pay.test.sankuai.com/certify-center/change-realname.html',
  [Runtime.Local]: 'https://paymp.pay.test.sankuai.com/certify-center/change-realname.html',
};

export const NOT_SELF_WITHDRAW_203_URL = {
  [Runtime.Prod]: 'https://npay.meituan.com/verified-sdk/not-self-withdraw.html',
  [Runtime.Staging]: 'https://stable.pay.st.sankuai.com/verified-sdk/not-self-withdraw.html',
  [Runtime.Test]: `${window.location.origin}/verified-sdk/not-self-withdraw.html`,
  [Runtime.Dev]: 'https://stable.pay.test.sankuai.com/verified-sdk/not-self-withdraw.html',
  [Runtime.Local]: 'https://stable.pay.test.sankuai.com/verified-sdk/not-self-withdraw.html',
};

export const INDEX_NAV_OPTIONS = {
  questions: `${window.location.origin}/resource/ibalance/faq.html?scene=faq`, // 常见问题
  'check-bill': `${window.location.origin}/resource/ibalance/record.html${window.location.search}`, // 查看明细
  'satisfaction-feedback': 'https://wenjuan.meituan.com/m/survey/5307040', // 用户满意度问卷调查
  'check-account': REAL_NAME_SEARCH_URL[runtime], // 查询名下余额
  'change-realname': CHANGE_REAL_NAME_URL[runtime], // 更换实名
};

export const REFUND_DATA_NAV_OPTIONS = {
  questions: `${window.location.origin}/resource/ibalance/faq.html?scene=faq`, // 常见问题
  'check-bill': `${window.location.origin}/resource/ibalance/record.html?pageType=refund`, // 查看退款明细
};

export enum WithdrawConfirmStatus {
  SUCCESS = 1,
}

export enum AuthenticationType {
  PasswordVerify = 1, // 支付密码验证（独立验证）
  AuthCertify, // 身份信息验证（实名认证）
}

export enum TradeType {
  Income = 1,
  Expend,
}

export enum BankStatus {
  NORMAL = 0,
  MAINTAINING = 1,
}

export enum OperationType {
  WITHDRAW = 1, // 余额提现
  SPEND = 2, // 使用余额
  DONATE = 3, // 捐赠并放弃余额
  CHANGE_NAME = 4, // 转移至新实名账户
  ABONDON = 5, // 放弃余额
  NOT_ME_201 = 6, // 实名非本人余额转出-201账户
  NOT_ME_203 = 7, // 实名非本人余额转出-203账户
}

export const WITHDRAW_STATE_LS_KEY = 'iBalanceWithdrawState';

export enum WithdrawAccountStatus {
  OPEN_HAS_CARD = 1,
  OPEN_NO_CARD = 2,
  NOT_OPEN_REALNAME_HAS_CARD = 3,
  NOT_OPEN_REALNAME_NO_CARD = 4,
  NOT_OPEN_NO_REALNAME_NO_CARD = 5,
}
